import type { InputT } from "@/types/database/forms";

interface Props {
	inputs: InputT[];
}

const useRepeatableGroupsInputs = (props: Props) => {
	// Early return if no inputs
	if (!props?.inputs || props.inputs.length === 0) {
		return [];
	}

	// Find all repeatable group inputs
	const repeatableGroups = props.inputs.filter(
		(input) => input?.input_key === "repeatable-group",
	);

	// If no repeatable groups, return empty array
	if (repeatableGroups.length === 0) {
		return [];
	}

	// Extract all input values from repeatable groups' input_list
	const inputValues: string[] = [];

	for (const group of repeatableGroups) {
		if (group?.input_list && Array.isArray(group.input_list)) {
			inputValues.push(...group.input_list);
		}
	}

	return inputValues;
};

export default useRepeatableGroupsInputs;
